import React from "react";
import skillsData from "../assets/documents/skills.json";

const Skills = () => {
  return (
    <div id="skills" className="py-4 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-8">My Skills</h2>

        {skillsData.map((category) => (
          <div key={category.category} className="mb-12">
            <h3 className="text-2xl font-semibold mb-6 pb-2 border-b-2 border-indigo-600">
              {category.category}
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
              {category.skills.map((skill) => (
                <div key={skill.name} className="w-full">
                  <div
                    className="bg-white rounded-lg shadow-md p-4 h-full 
                                  transition-all duration-300 ease-in-out 
                                  hover:shadow-lg hover:-translate-y-1"
                  >
                    <div className="flex flex-col items-center justify-center space-y-3">
                      <img
                        src={skill.logo}
                        alt={`${skill.name} logo`}
                        className="w-16 h-16 object-contain"
                      />
                      <p className="text-center font-medium">{skill.name}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
